import { _ as t } from "../internals/export.js";
import { m as a } from "../internals/math-expm1.js";
var r = Math.exp;
t({
  target: "Math",
  stat: !0
}, {
  tanh: function tanh(t) {
    var n = +t,
      e = a(n),
      m = a(-n);
    return e == 1 / 0 ? 1 : m == 1 / 0 ? -1 : (e - m) / (r(n) + r(-n));
  }
});